export const TAG_TYPE1_SYSTEM = 'system';
export const TAG_TYPE1_USER = 'user';
export const TAG_TYPE2_DEFAULT = 'default';
export const TAG_NAME_CHOUKI_HOZON = '長期保存';
